import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom'
import Home from './pages/home/Home'
import AskAI from './pages/askAi/AskAI'
import CreateVisual from './pages/createVisual/CreateVisual'
import { AppContent } from './services/appContent/AppContent'
import LoginForm from './pages/auth/components/LoginForm'
import Logout from './pages/auth/components/Logout'
import RootError from './pages/error/RootError'
import Dashboards from './pages/dashboards/Dashboards'
import Visualisations from './pages/visualisations/Visualisations'
import Subscriptions from './pages/subscriptions/Subscriptions'
import { Maintenance } from './pages/maintenance/Maintenance'
import useTSMaintenanceStatus from './hooks/useTSMaintenanceStatus'
import { MangoSplash } from '@intellihr/blueberry'
import Dashboard from './pages/dashboards/Dashboard'
import Error404 from './pages/error/Error404'
import Visualisation from './pages/visualisations/Visualisation'
import Kpi from './pages/kpi/Kpi'

function App() {
  const { isTSUnderMaintenance, loading } = useTSMaintenanceStatus()

  if (loading) {
    return <MangoSplash />
  }
  let router
  if (isTSUnderMaintenance) {
    router = createBrowserRouter([
      {
        path: '*',
        element: <Maintenance />,
      },
    ])
    return <RouterProvider router={router} />
  }

  router = createBrowserRouter([
    {
      path: '/',
      element: <AppContent />,
      errorElement: <RootError />,
      children: [
        {
          path: '/',
          element: <Home />,
        },
        {
          path: '/ask-ai',
          element: <AskAI />,
        },
        {
          path: '/dashboards',
          children: [
            {
              index: true,
              element: <Dashboards />,
            },
            {
              path: 'dashboard',
              element: (
                <Navigate
                  to="/dashboards"
                  replace
                />
              ),
            },
            {
              path: 'dashboard/:dashboardId',
              element: <Dashboard />,
            },
          ],
        },
        {
          path: '/create-visual',
          element: <CreateVisual />,
        },
        {
          path: '/visualisations',
          children: [
            {
              index: true,
              element: <Visualisations />,
            },
            {
              path: 'visualisation',
              element: (
                <Navigate
                  to="/visualisations"
                  replace
                />
              ),
            },
            {
              path: 'visualisation/:visualisationId',
              element: <Visualisation />,
            },
          ],
        },
        {
          path: '/subscriptions',
          element: <Subscriptions />,
        },
        {
          path: '/kpi/:dashboardId/:kpiId',
          element: <Kpi />,
        },
        {
          path: '/login',
          element: <LoginForm />,
        },
        {
          path: '/logout',
          element: <Logout />,
        },
        {
          path: '/error404',
          element: <Error404 />,
        },
        {
          path: '*',
          element: <Home />,
        },
      ],
    },
  ])

  return <RouterProvider router={router} />
}

export default App
